const defaults = {
    context: {
        ApplyUpdates: 'Apply Updates',
        AutoshipSelectorAriaLabel: 'Choose an autoship option',
        AutoshipFrequencyAriaLabel: 'Choose your autoship frequency',
        Checkout: 'Checkout',
        ContinueShoppingLink: {
            Text: "Continue Shopping",
            Url: "/shopmyvca"
        },
        Discounts: 'Discounts',
        Flavor: 'Flavor:',
        Loading: "Loading...",
        LoadingLine: '{0} Loading...',
        OrderSummary: 'Order Summary',
        ModalLineUpdateHeading: "Unsaved Changes",
        ModalLineUpdateBody: "<p>You have unsaved changes pending. Apply your current updates or continue without your most recent changes.</p>",
        ModalLineUpdateApplyUpdates: "Apply Updates", 
        ModalLineUpdateContinue: "Continue",
        ModalCheckoutHeading: "Unsaved Changes",
        ModalCheckoutBody: "<p>You have unsaved changes pending. Apply your updates before making any more changes.</p>",
        ModalCheckoutApplyUpdates: "Apply Updates", 
        ModalCheckoutContinue: "Continue",
        Packaging: 'Packaging:',
        PetSelector: 'Pet for this product',
        PetSelectorAriaLabel: 'Choose a pet for this product',
        PetSelectorError: 'All products in the cart need to have a pet selected.',
        BackOrderError: 'Please remove out of stock items from cart to proceed with checkout.',
        PrescriptionRequired: '* Prescription Required',
        Price: 'Price:',
        Promotions: 'Promotions and discounts will be applied at checkout',
        Shipping: 'Estimated Shipping',
        StrengthSize: 'Strength / Size:',
        StrengthSizeSupplies: 'Strength / Size Supplies:',
        Subtotal: 'Subtotal',
        Remove: 'Remove',
        RxForm: 'Rx Form:',
        Tax: 'Estimated Tax',
        Total: 'Estimated Total',
        YourShoppingCartEmpty: 'Your Shopping Cart is Empty',
        AutoshipOptions: [
            {
                AutoshipName: 'Subscribe With Never Forget®',
                AutoshipFrequency: '7'
            },
            {
                AutoshipName: 'One Time Purchase',
                AutoshipFrequency: '0'
            }
        ],
        FrequencyOptions: [
            {
                FrequencyName: 'Weekly',
                FrequencyValue: '7'
            },
            {
                FrequencyName: 'Two Weeks',
                FrequencyValue: '14'
            },
            {
                FrequencyName: 'Three Weeks',
                FrequencyValue: '21'
            },
            {
                FrequencyName: '30 Days',
                FrequencyValue: '30'
            },
            {
                FrequencyName: 'Five Weeks',
                FrequencyValue: '35'
            },
            {
                FrequencyName: 'Six Weeks',
                FrequencyValue: '42'
            },
            {
                FrequencyName: 'Seven Weeks',
                FrequencyValue: '49'
            },
            {
                FrequencyName: 'Eight Weeks',
                FrequencyValue: '56'
            },
            {
                FrequencyName: 'Nine Weeks',
                FrequencyValue: '63'
            },
            {
                FrequencyName: 'Ten Weeks',
                FrequencyValue: '70'
            },
            {
                FrequencyName: 'Eleven Weeks',
                FrequencyValue: '77'
            },
            {
                FrequencyName: 'Twelve Weeks',
                FrequencyValue: '84'
            },
            {
                FrequencyName: 'Four Months',
                FrequencyValue: '112'
            },
            {
                FrequencyName: 'Five Months',
                FrequencyValue: '140'
            },
            {
                FrequencyName: '180 Days',
                FrequencyValue: '180'
            }
        ],
    }
};

export {
    defaults
};
